import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { ResultModel } from './result.model';

@Component({
  selector: 'app-remocao-comunicacao',
  templateUrl: './remocao-comunicacao.component.html',
  styleUrls: ['./remocao-comunicacao.component.scss'],
})
export class RemocaoComunicacaoComponent implements OnInit {

  public exibiConteudo: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private fidelidadeService: FidelidadeService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.validarToken(params.token);
    });
  }

  private validarToken(tokenUrl: string): void {
    if (!tokenUrl) this.loginRedirect();

    this.authService.validacaoTokenSemLifeTime(tokenUrl)
      .subscribe(
        sucesso => this.atualizarComunicacao(sucesso),
        _ => this.loginRedirect()
      );
  }

  private atualizarComunicacao(response: ResultModel) {
    this.fidelidadeService.atualizarAceiteDeComunicacao(response.token, false)
      .subscribe({
        next: _ => this.exibirPagina(),
        error: (err: any) => console.log(err)
      });
  }

  private loginRedirect(): void {
    this.router.navigate(["/"]);
  }

  private exibirPagina = () =>
    this.exibiConteudo = true;
}
